import { useEffect, useState } from 'react';
import { useIsFocused } from 'expo-router';

// NativeTabs eagerly renders every stack. Defer expensive content until its
// first visit, then keep it mounted so navigating back preserves screen state.
const DeferredUntilFocused = ({ children, deferMount = false, fallback = null }) => {
    const focused = useIsFocused();
    const [visited, setVisited] = useState(false);

    useEffect(() => {
        if (!focused || visited) return;
        if (!deferMount) {
            setVisited(true);
            return;
        }
        // Let the native loading indicator paint before synchronous mount work.
        let frame = requestAnimationFrame(() => {
            frame = requestAnimationFrame(() => setVisited(true));
        });
        return () => cancelAnimationFrame(frame);
    }, [focused, visited, deferMount]);

    if (deferMount && !visited) return focused ? fallback : null;
    return focused || visited ? children : null;
};

export default DeferredUntilFocused;
